"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerBetCommand = void 0;
const draw_deck_player_action_1 = require("../../actions/draw-deck-player-action");
const draw_deck_croupier_action_1 = require("../../actions/draw-deck-croupier-action");
const draw_deck_croupier_hidden_action_1 = require("../../actions/draw-deck-croupier-hidden-action");
const player_command_1 = require("./player-command");
const logic_types_1 = require("../../logic-types");
const player_blackjack_rule_1 = require("../../game-rules/player-blackjack-rule");
const croupier_blackjack_rule_1 = require("../../game-rules/croupier-blackjack-rule");
const show_controls_rule_1 = require("../../game-rules/show-controls-rule");
const withdraw_chips_action_1 = require("../../preprocessor-actions/withdraw-chips-action");
const set_player_bet_action_1 = require("../../preprocessor-actions/set-player-bet-action");
class PlayerBetCommand {
    constructor(betAmount) {
        this.betAmount = betAmount;
    }
    static isCommand(command) {
        return command instanceof PlayerBetCommand;
    }
    serializeToString() {
        return `${player_command_1.CommandTypes.Bet} ${this.betAmount}`;
    }
    validateCommand(context) {
        if (context.gameState.getRoundState() !== logic_types_1.RoundState.Deal) {
            return false;
        }
        if (this.betAmount <= 0) {
            return false;
        }
        if (!Number.isInteger(this.betAmount)) {
            return false;
        }
        if (!context.gameState.canWithdrawChips(this.betAmount)) {
            return false;
        }
        return true;
    }
    executeCommand(commandHash, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            context.gameState.setRoundState(logic_types_1.RoundState.Transition, instant);
            const actions = [
                new draw_deck_player_action_1.DrawDeckPlayerAction(context.playerManager.board, logic_types_1.PileId.Player1),
                new draw_deck_croupier_action_1.DrawDeckCroupierAction(context.playerManager.board),
                new draw_deck_player_action_1.DrawDeckPlayerAction(context.playerManager.board, logic_types_1.PileId.Player1),
                new draw_deck_croupier_hidden_action_1.DrawDeckCroupierHiddenAction(context.playerManager.board),
            ];
            for (const action of actions) {
                action.execute();
            }
            [
                new set_player_bet_action_1.SetPlayerBet(this.betAmount, logic_types_1.PileId.Player1),
                new withdraw_chips_action_1.WithdrawChipsAction(),
            ].forEach((element) => {
                element.execute(context.playerManager, context.gameState, instant);
            });
            context.eventQueue.enqueue({
                type: "onPlayerBet",
                instant,
                payload: { betAmount: this.betAmount },
            });
            yield context.dealProcessor.disclosePendingCards(commandHash);
            for (const action of actions) {
                action.resolve();
                const player = context.playerManager.playerFromId(logic_types_1.PileId.Player1);
                if (draw_deck_player_action_1.DrawDeckPlayerAction.isAction(action)) {
                    context.eventQueue.enqueue({
                        type: "onDrawDeckPlayer",
                        instant,
                        payload: { player: player.clone(), cardIndex: action.cardIndex },
                    });
                }
                else if (draw_deck_croupier_action_1.DrawDeckCroupierAction.isAction(action)) {
                    context.eventQueue.enqueue({
                        type: "onDrawDeckCroupier",
                        instant,
                        payload: {
                            croupier: context.playerManager.croupier.clone(),
                            cardIndex: action.cardIndex,
                        },
                    });
                }
                else if (draw_deck_croupier_hidden_action_1.DrawDeckCroupierHiddenAction.isAction(action)) {
                    context.eventQueue.enqueue({
                        type: "onDrawDeckCroupierHidden",
                        instant,
                        payload: {
                            croupier: context.playerManager.croupier.clone(),
                            cardIndex: action.cardIndex,
                        },
                    });
                }
            }
            yield this.resultRules().execute(commandHash, instant, context);
        });
    }
    resultRules() {
        const playerBlackjackRule = new player_blackjack_rule_1.PlayerBlackjackRule(logic_types_1.PileId.Player1);
        const croupierBlackjackRule = new croupier_blackjack_rule_1.CroupierBlackjackRule(logic_types_1.PileId.Player1);
        const showControlsRule = new show_controls_rule_1.ShowControlsRule();
        playerBlackjackRule
            .setNext(croupierBlackjackRule)
            .setNext(showControlsRule);
        return playerBlackjackRule;
    }
}
exports.PlayerBetCommand = PlayerBetCommand;
